import { FormActionButton } from '@workwave-tidal/core/form'

import { useDriverAssignmentEditMode } from '@/atoms'

import { form } from './formState'
import { useOnCancel } from './hooks/useOnCancel'
import { useTexts } from './hooks/useTexts'

interface Props {
  recurrence: uui.domain.rm.Recurrence
}

export function Footer({ recurrence }: Props) {
  const onCancel = useOnCancel(recurrence.source)
  const [editMode] = useDriverAssignmentEditMode()

  const creating = editMode === 'create'
  const texts = useTexts()

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  // When creating a new entity the submit button should be enabled also when the form is in a pristine status
  const saveDisabled = creating
    ? validating || submitting
    : status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.cancel}
        size="medium"
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
        onClick={onCancel}
      />
      <FormActionButton
        size="medium"
        type="submit"
        label={texts.save(recurrence)}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
        variant="contained"
        loading={submitting || validating}
        disabled={saveDisabled}
      />
    </>
  )
}
